export const adap_datos_pago = (datosPago, pedido) => {

    let obj = {
        nombre: datosPago.customer_data && datosPago.customer_data.full_name ? datosPago.customer_data.full_name : pedido.nombres + ' ' + pedido.apellidos,
        fecha: new Date(datosPago.created_at),
        valor: datosPago.amount_in_cents / 100,
        estadoPago: datosPago.status,
        estado: pedido.estado,
        consecutivo: pedido.consecutivo,
        idPedido: pedido.id,
        mensaje: datosPago.status_message ? datosPago.status_message : '',
        metodo: datosPago.payment_method_type,
        valorEnvio: pedido.valorEnvio ? pedido.valorEnvio : 0,
        empresaEnvio: pedido.empresaEnvio,
        tiempoEnvio: pedido.tiempoEnvio,
        productos: pedido.productos,
        idTransaccion: datosPago.id,
        celular: pedido.celular,
        valorDescuento: pedido.valorDescuento,
        ciudad: pedido.ciudad,
    }

    return obj
}